import { render, staticRenderFns } from "./BoxItemEditor.vue?vue&type=template&id=8fdde0b0&scoped=true&"
import script from "./BoxItemEditor.vue?vue&type=script&lang=js&"
export * from "./BoxItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemEditor.vue?vue&type=style&index=0&id=8fdde0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdde0b0",
  null
  
)

export default component.exports